module.exports = __webpack_public_path__ + "images/questions/qa_bg_dot_blue_3daee758d82425f08fda2f2c75ecde6f.png";